const canvas = {
  showGrid: "Показать сетку",
  snapToGrid: "Привязка к сетке",
  zoom: "Масштаб",
  addField: "Добавить поле",
  placedBy: "Размещено",
  placedAt: "Дата размещения",
  lastMoved: "Последнее перемещение",
  usedInDocuments: "Используется в документах",
  fieldGraph: "Граф полей",
  editorZone: "Зона редактирования",
  resetLayout: "Сбросить макет",
  documents: "Документы",
  fields: "Поля",
  documentTitle: "Название документа",
  saving: "Сохранение...",
  saved: "✓ Сохранено",
  retrying: "Повтор...",
  saveError: "⚠ Ошибка сохранения",
  conflict: "⚠ Конфликт",
  offline: "☁ Офлайн — сохранено локально",
  editorWidth: "Ширина редактора",
  widthNarrow: "Узкий",
  widthMedium: "Средний",
  widthWide: "Широкий",
  widthFull: "Полный",
} as const;
export default canvas;
